import { get } from 'lodash';
import { createSelector } from 'reselect';

export const selectors = {
  allSettings: state => get(state, 'account.settings.data', {}),
  loading: state => get(state, 'account.settings.loading'),
};

selectors.loadedSettings = createSelector([selectors.allSettings], settings => Object.keys(settings));
